<template>
    <Fragment>
        <div v-if="!this.inCart" class="input-group input_num mt_xs">
            <div class="input-group-prepend">
                <button
                    class="btn btn_lg btn_form"
                    type="button"
                    @click.prevent="minus()"
                >
                    <i class="f7-icons icon_sm">minus_circle</i>
                </button>
            </div>
            <input
                type="text"
                class="form-control input_w_btn"
                placeholder="0"
                v-model="qty"
                @change="setQty($event.target.value)"
            />
            <div class="input-group-append">
                <button
                    id="add-to-cart-plus"
                    class="btn btn_lg btn_form"
                    type="button"
                    @click.prevent="plus()"
                >
                    <i class="f7-icons icon_sm">plus_circle</i>
                </button>
                <b-popover
                    ref="plusPopover"
                    target="add-to-cart-plus"
                    :disabled.sync="popoverIsDisabled"
                    placement="bottom">
                    Выбрано максимальное количество
                </b-popover>
            </div>
        </div>
        <button
            class="btn btn_lg btn_cart btn_icontext ci_action_cart mt_xs"
            v-bind:class="{ active: this.inCart }"
            @click.prevent="inCart ? goToCart(id) : addToCart(id)"
        >
            <i class="f7-icons icon_lg">cart</i>
            {{ inCart ? "Перейти в корзину" : "Добавить в корзину" }}
        </button>
    </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

export default {
    props: ["id", "qty_per_pack", "qty_in_stock", "set_id", "title", "sku", "category", "price"],

    components: { Fragment },

    data: function () {
        return {
            in_stock: parseInt(this.qty_in_stock),
            per_pack: parseInt(this.qty_per_pack),
            popoverIsDisabled: true,
            qty: parseInt(this.qty_in_stock) ? parseInt(this.qty_per_pack) : 0
        };
    },

    computed: {
        inCart() {
            if (this.set_id) {
                if (this.set_id in this.$store.state.cart.groups) {
                    return true;
                } else {
                    return false;
                }
            }

            return this.$store.state.cart.items.find((x) => {
                return x.id == parseInt(this.id) && !parseInt(x.set_id);
            });
        },
    },

    methods: {
        addToCart() {
            let params = {
                id: this.id,
                qty: this.qty,
                title: this.title,
                sku: this.sku,
                category: this.category,
                price: this.price,
            };

            if (typeof this.set_id !== "undefined" && this.set_id) {
                params.set = this.set_id;
            }

            this.$store.dispatch("cart/addToCart", params);
        },

        deleteFromCart() {
            let params = {
                id: this.id,
                qty: this.qty,
                title: this.title,
                sku: this.sku,
                category: this.category,
                price: this.price,
            };

            this.$store.dispatch("cart/deleteFromCart", params);
        },

        goToCart() {
            location.href = '/cart';
        },

        plus() {
            let qty = this.qty + this.per_pack;

            this.$refs.plusPopover.$emit('close');

            if (qty > this.in_stock) {
                this.qty =
                    Math.floor(this.in_stock / this.per_pack) * this.per_pack;
                this.$refs.plusPopover.$emit('open');

                setTimeout(() => {
                    this.$refs.plusPopover.$emit('close');
                }, 3000);
            } else {
                this.qty = qty;
            }
        },

        minus() {
            this.$refs.plusPopover.$emit('close');

            if (this.qty > this.per_pack) {
                this.qty = this.qty - this.per_pack;
            }
        },

        setQty(qty) {
            this.$refs.plusPopover.$emit('close');

            if (qty > this.in_stock) {
                this.qty =
                    Math.floor(this.in_stock / this.per_pack) * this.per_pack;
                this.$refs.plusPopover.$emit('open');

                setTimeout(() => {
                    this.$refs.plusPopover.$emit('close');
                }, 3000);
            } else if (qty == 0) {
                this.qty = this.per_pack;
            } else {
                this.qty = Math.floor(qty / this.per_pack) * this.per_pack;
            }
        },
    },
};
</script>
